export const INCREMENT_COUNTER = 'INCREMENT_COUNTER';
export const DECREMENT_COUNTER = 'DECREMENT_COUNTER';

export const COUNTER_ACTION_STARTED = "COUNTER_ACTION_STARTED";
export const COUNTER_ACTION_FINISHED = "COUNTER_ACTION_FINISHED";


// WEBPACK FOOTER //
// ./src/features/testarea/testConstants.jsx